import {Box, Container, styled} from '@mui/material';

type StyledFooterContainerProps = {
	$hasBottomButton?: boolean;
};

export const StyledContainer = styled(Container)`
	margin-top: 32px;
`;

export const StyledFooterContainer = styled(Box)<StyledFooterContainerProps>`
	margin: auto 0px 16px;
	padding-top: 40px;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin: auto 0px 0px;
		& footer {
			margin-inline: 24px;
		}
	}

	${({theme}) => theme.breakpoints.up('md')} {
		margin: auto 24px 0px;
		& footer {
			margin-inline: 0px;
		}
	}
`;
